import { Typography, TypographyProps } from '@mui/material'

const UtilizationTextIcon = () => {
  return (
    <Typography fontSize="inherit" fontWeight="inherit">
      η
    </Typography>
  )
}

const UtilizationC90TextIcon = () => {
  return (
    <Typography fontSize="inherit" fontWeight="inherit">
      η<sub>c,90</sub>
    </Typography>
  )
}

const KC90TextIcon = () => {
  return (
    <Typography fontSize="inherit" fontWeight="inherit">
      k<sub>c,90</sub>
    </Typography>
  )
}

const FC90KTextIcon = () => {
  return (
    <Typography fontSize="inherit" fontWeight="inherit">
      f<sub>c,90,k</sub>
    </Typography>
  )
}

const LintelWidthTextIcon = (props: TypographyProps) => {
  return (
    <Typography fontSize="inherit" {...props}>
      B<sub>Sturz</sub>
    </Typography>
  )
}

const SupportWidthTextIcon = (props: TypographyProps) => {
  return (
    <Typography fontSize="inherit" {...props}>
      b
    </Typography>
  )
}

export {
  UtilizationTextIcon,
  UtilizationC90TextIcon,
  KC90TextIcon,
  LintelWidthTextIcon,
  SupportWidthTextIcon,
  FC90KTextIcon,
}
